import { Skeleton } from '@/common/components/ui/skeleton';

export const DetailsTabSkeleton = () => (
  <div className="max-w-4xl mt-6 space-y-6">
    <Skeleton className="h-[250px] rounded-xl" />
    <Skeleton className="h-[200px] rounded-xl" />
    <div className="flex justify-end">
      <Skeleton className="h-9 w-[120px]" />
    </div>
  </div>
);
